import React from "react";
import CellWithTwoLabels from "./../shared/groups/CellWithTwoLabels";
import moment from "moment";
import style from "../../assets/css/modules/notifications/notification.css";
import { handleKeyPress } from "../../helpers/KeyPressHelper";
import { connect } from "react-redux";
import { setPaymentDetailsForNotification } from "../../actions/claims/claimsActions";
import { withRouter } from "react-router-dom";

const createBottomLabel = (content, notification) => [
  content.claimReferencePrefix,
  " ",
  notification.ClaimReference,
  <span className={style.createdDate}>
    {moment(notification.CreatedDate).format("Do MMMM YYYY")}
  </span>
];

export const Notification = ({
  content,
  notification,
  removeNotification,
  history,
  isInternalView,
  setPaymentDetailsForNotification
}) => {
  let removeLinkProps = {
    className: style.removeLinkDisabled
  };
  if (!isInternalView) {
    removeLinkProps = {
      className: style.removeLink,
      onClick: removeNotification,
      onKeyPress: (e) => handleKeyPress(e, removeNotification)
    };
  }

  return (
    <React.Fragment>
      <div className={"row " + style.notification}>
        <div className={"col " + style.contentWrapper}>
          <div className={style.iconWrapper}>
            <i className="icon-notification" />
          </div>
          <div
            className={style.cellWrapper}
            id="notificationLink"
            onKeyPress={(e) =>
              handleKeyPress(
                e,
                setPaymentDetailsForNotification(
                  notification.InvoiceReference,
                  history,
                  notification.SecurityId
                )
              )
            }
            onClick={() => {
              setPaymentDetailsForNotification(
                notification.InvoiceReference,
                history,
                notification.SecurityId
              );
            }}
          >
            <CellWithTwoLabels
              topLabelStyleOverride={style.topLabelStyleOverride}
              bottomLabelStyleOverride={style.bottomLabelStyleOverride}
              topLabel={
                notification.IsActionRequired
                  ? content.paymentNeeded
                  : content.weHavePaid
              }
              bottomLabel={createBottomLabel(content, notification)}
            />
          </div>

          {
            <div className={style.removeLinkWrapper}>
              <div {...removeLinkProps} id="removeLink">
                {content.removeLink}
              </div>
            </div>
          }
        </div>
      </div>
      <hr />
    </React.Fragment>
  );
};

export const mapStateToNotifcation = ({ policyReducer }) => {
  return {
    isInternalView:
      policyReducer.policyDetails && policyReducer.policyDetails.IsInternalView
  };
};

export default withRouter(
  connect(mapStateToNotifcation, { setPaymentDetailsForNotification })(
    Notification
  )
);
